import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Featurestrip() {
  return (
    <section className="features_trip p-100 text_trip">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="feature_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/feature_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={746}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              Platform <span>Features</span>
            </h2>
            <ul>
              <li>
                <h5>Online Booking & Order Tracking</h5>
                <p>
                  The platform has all the features to find and reserve a slot
                  and track the orders to execute the task and fulfill
                  requirements effectively.
                </p>
              </li>
              <li>
                <h5>Timely Notifications</h5>
                <p>
                  The platform sends timely notifications regarding orders, the
                  latest developments, and any promotions that might fascinate
                  the users.
                </p>
              </li>
              <li>
                <h5>Employee Management</h5>
                <p>
                  The platform has a custom-built employee management portal
                  that can be used to manage trips, track them and do much more.
                </p>
              </li>
              <li>
                <h5>Flight Management</h5>
                <p>
                  For foreign transportation needs, the platform has a flight
                  management portal that provides real-time updates regarding
                  the package.
                </p>
              </li>
              <li>
                <h5>Payment Processing & Reporting</h5>
                <p>
                  The Equitrip platform has an in-built payment processing and
                  reporting system that can be used to see payment history and
                  extract custom reports.
                </p>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Featurestrip;
